export default __webpack_public_path__ + "static/media/logo.fc952b4b.webp";